import React from 'react';
import { Helmet } from 'react-helmet';
import Hero from '@/components/Hero';
import RaceInfo from '@/components/RaceInfo';
import Gallery from '@/components/Gallery';

const HomePage = () => {
  return (
    <>
      <Helmet>
        <title>Banyumas Ultra - Taklukkan Jalur Liar Banyumas Raya</title>
        <meta name="description" content="Bergabunglah dalam petualangan lari trail epik di Banyumas, Jawa Tengah. Taklukkan jalur liar di rute Banyumas Raya dan temukan keindahan alam yang memukau." />
      </Helmet>
      <Hero />
      <RaceInfo />
      <Gallery />
    </>
  );
};

export default HomePage;